import React from 'react';

const Play = ({className, style}) => (
  <div className={className} style={{...style}}>
    <svg version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 50 512 512"><path d="M152.443 136.417L359.557 255.99 152.443 375.583z" fill="#fff" /></svg>
  </div>
);

Play.defaultProps = {
  style: {
  },
};

export default Play;
